import { AppRootScope } from '../../typings/AppRootScope';

// This directive will display a list of key/value pairs.
var propertyDataListDirective = ['$compile', '$parse', '$rootScope', function (
    $compile: angular.ICompileService,
    $parse: angular.IParseService,
    $rootScope: AppRootScope
) {

    return {
        restrict: 'E',

        link: function (scope: any, element: angular.IAugmentedJQuery, attrs: any) {

            var propertyObj = $parse(attrs.properties)(scope);
            scope.nameValuePairs = getKeyValuesPairs(propertyObj);

            var list = createCommaSeparatedListing($rootScope.currentTheme.name, scope.nameValuePairs);

            $compile(list)(scope);
            element.append(list);
        }
    };

    function createCommaSeparatedListing(currentTheme: string, keyValues: Array<{key: string, value: any}>) {

        var container = $('<div class="definition-listing"></div>');
        keyValues.forEach(function (keyValue: any) {

            var dt = $('<span class="term"></span>').text(keyValue.key);

            // Must qualify the color with the currentTheme name since this uses $compile
            var dd = $('<span class="definition" md-colors="{ color: \'' + currentTheme + '-accent\' }""></span>').text(keyValue.value);

            container.append(dt, dd);
        });

        return container;
    }

    function getKeyValuesPairs(obj: any): any[] {

        var keyValues = [];

        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                keyValues.push({ key: p, value: obj[p] });
            }
        }
        return keyValues;
    }
}];

export default propertyDataListDirective;
